<template>
  <div class="page">
    <div class="normal">
      <div class="give-box">
        <h2>官方选房师分配客户</h2>
        <div class="normal">
          目标楼盘
          <el-select
            ref="agent2Select"
            @hook:mounted="cancalReadOnly"
            @visible-change="cancalReadOnly"
            v-model="giveFromEstate"
            filterable
            placeholder="选择楼盘"
            default-first-option
            :remote-method="searchEstate1"
            remote
            clearable
          >
            <el-option
              v-for="(item, index) in jpEstates"
              :key="index"
              :label="item.real_estate_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="normal">
          限制日期
          <el-date-picker
            size="small"
            v-model="limit_date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
          <span>默认选取15天内</span>
        </div>
       

        <div class="normal">
          查询数量
          <el-button @click="toCheckCustomer">开始查询</el-button>
        </div>

        <div v-if="Object.keys(hasNumMap).length">
          <div v-for="giveKey in giveKeys" :key="giveKey" style="display: flex; gap: 10px; height: 40px;align-items: center;">
            <div style="width: 70px;">{{ giveKeyMap[giveKey] }}</div>
            <input v-model="giveNumMap[giveKey]" placeholder="分配人数" style="height: 20px;"/>
            <span style="margin-left: 10px;">可分配{{ hasNumMap[giveKey] }}人</span>
          </div>
        </div>

        <div v-if="estateSales.length" class="normal">
          选择选房师
          <div class="sale-box">
            <div
              :class="{ 'current-sale': chooseSaleId === sale.erp_uid }"
              v-for="sale in estateSales"
              :key="sale.erp_uid"
              @click="chooseSaleId = sale.erp_uid"
            >
              {{ sale.saleInfo.user_name }}
            </div>
          </div>
        </div>

        <div class="normal">
          分配客户
          <el-button @click="toGiveCustomer">开始分配</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeDate: "",
      matchEstates: [],
      giveToEstate: "",
      estateSales: [],
      giveFromEstate: "",
      jpEstates: [],
      giveNum: "",
      chooseSaleId: "",
      limit_date: "",
      checkEstate: "",
      checkEstates: [],
      checkInfoList: [],
      checkInfoIndex: 0,
      customers: [],
      customerTitle: "",
      hasNumMap: {}, //查询到可分配的人数
      giveNumMap: {}, //要分配的人数
      giveKeys: [
        "call",
        "talk",
        "collect",
        "visit",
        "houseSelection",
      ],
      giveKeyMap: {
        call: "来电",
        talk: "咨询",
        collect: "关注",
        visit: "浏览",
        houseSelection: "选房服务",
      },
      notes: "",
      clickState: false,
      checkVisible: false,
      tempRow: {},
      allData: [], //所有查询的楼盘信息
    };
  },
  mounted()
  {
    this.getEstateSales()
  },
  methods: {
    changeEstate(data) {
      const { value, label } = data;
    },
    addnotes(data) {
      this.checkVisible = true;
      this.tempRow = data;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    async onPlay(data, sound) {
      let res = await this.$axios.post(
        this.$url_prefix + "recordingnotes/add",
        {
          _id: data._id,
          sound,
        }
      );
      if (res.data.success) {
        data.sound_complete = true;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    searchEstate(search) {
      let that = this;
      if (search) {
        that.$axios
          .get(that.$url_prefix + "searchEstateName", {
            params: {
              search: search,
            },
            timeout: 30 * 1000,
          })
          .then((res) => {
            console.log(res);
            that.matchEstates = res.data.data;
          });
      }
    },

    toCheckCustomer() {
      let that = this;
      if (!that.giveFromEstate) {
        that.$message.error("请选择楼盘");
        return;
      }
      that.giveCustomerCircle({
        from_id:that.giveFromEstate,
        operate: "查询",
        limit_date: that.limit_date,
        timestamp: new Date().getTime(),
      });
    },

    // 点击开始分配
    toGiveCustomer() {
      let that = this;
      if (!that.giveFromEstate) {
        that.$message.error("请选择目标楼盘");
        return;
      }
      if (!that.chooseSaleId) {
        that.$message.error("请选择分配顾问");
        return;
      }
      if(JSON.stringify(that.giveNumMap) == '{}'){
        that.$message.error("未填写分配项");
        return;
      }
      // 对分配数量进行判断
      for (let key in that.giveNumMap) {
          // if(that.giveNumMap[key] == 0){
          //   that.$message.error("分配数量不能为0");
          //   return;
          // }
          if(that.giveNumMap[key]>that.hasNumMap[key]){
            that.$message.error("分配数量超出");
            return;
          }
      }
      that
        .$confirm("请确定分配数量，分配顾问等信息", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then((res) => {
          let params = {
            from_id: that.giveFromEstate,
            sale_id: that.chooseSaleId,
            operate: "分配",
            limit_date: that.limit_date,
            timestamp: new Date().getTime(),
          };
          let giveNumMap = that.giveNumMap;
          that.giveKeys.forEach((x) => {
            if (giveNumMap[x]) {
              params["give_num_" + x] = giveNumMap[x];
            }
          });
          that.giveCustomerCircle(params);
        })
        .catch((err) => {
          console.log("取消");
        });
    },

    async giveCustomerCircle(params) {
      let that = this;
      that.$open();
      try {
        let res = await that.$axios.post(
          that.$url_prefix + "giveXiaojiCustomer",
          params
        );

        if (!res.data.success) {
          that.$close();
          that.$message.error(res.data.msg);
          return;
        }

       let data = res.data.result; 
        // if (!data) {
        //   await that.sleep(2000);
        //   that.giveCustomerCircle(params);
        //   return;
        // }
        console.log("res", data);
        that.$close();
        if (params.operate === "分配") {
          that.$message({
            type: "success",
            message: "分配成功",
          });
          // 更新可分配人数
          for (let key in params) {
            if (key.includes("give_num_")) {
              let nkey = key.replace("give_num_", "");
              that.hasNumMap[nkey] = that.hasNumMap[nkey] - params[key];
            }
          }
        } else {
          that.hasNumMap = {
            call: data.call_users.length,
            talk: data.talk_users.length,
            collect: data.collect_users.length,
            visit: data.visit_users.length,
            houseSelection: data.service_users.length,
          };
          that.$message({
            type: "success",
            message: `查询成功`,
          });
        }
      } catch (err) {
        console.log("err", err);
        that.$close();
        that.$message.error("查询失败");
      }
    },

    getEstateSales() {
      let that = this;
      that.chooseSaleId = "";
      that.$axios
        .post(that.$url_prefix + "getXiaojiSale", {
        })
        .then((res) => {
          let estateSales = res.data.result || [];
          that.estateSales = estateSales.filter(x => x.erp_uid);
        });
    },

    searchEstate1(search) {
      let that = this;
      if (search) {
        that.$axios
          .get(that.$url_prefix + "searchEstateName", {
            params: {
              search: search,
            },
            timeout: 30 * 1000,
          })
          .then((res) => {
            that.jpEstates = res.data.data;
          });
      }
    },
    searchEstate2(search) {
      let that = this;
      if (search) {
        that.$axios
          .get(that.$url_prefix + "searchEstateName", {
            params: {
              search: search,
            },
            timeout: 30 * 1000,
          })
          .then((res) => {
            that.checkEstates = res.data.data;
          });
      }
    },

    async checkGiveInfo() {
      let that = this;
      that.allData = [];
      if (!that.checkEstate) {
        that.$message.error("请选择查询楼盘");
        return;
      }
      that.$open();
      that.checkEstate.forEach((item, index) => {
        let tempData = []; //暂存
        that.$axios
          .get(that.$url_prefix + "queryGiveCustomerInfo", {
            params: {
              estate_id: item,
            },
            timeout: 180 * 1000,
          })
          .then((res) => {
            tempData = {
              infoTitle: "",
              customerTitle: "",
              customers: [],
              infoData: [],
              checkInfoList: [],
              checkInfoIndex: [],
              timeDate: [],
            };
            if (!res.data.data.length) {
              tempData.infoTitle = res.data.estate_name
                ? res.data.estate_name + "暂无数据"
                : "暂无数据";
              // that.$message.error("没有查询到数据");
            } else {
              tempData.infoTitle = res.data.estate_name
                ? res.data.estate_name
                : "";
              tempData.infoData.push(...res.data.data[0].sales);
              tempData.checkInfoList = res.data.data;
              tempData.checkInfoIndex = [0];
              tempData.timeDate.push(res.data.data[0].date);
            }
            that.allData.push(tempData);
            if (index == that.checkEstate.length - 1) {
              that.allData = that.allData.splice(0, that.allData.length);
              setTimeout(() => {
                that.$close();
              }, 1000);
            }
          });
      });
    },

    seeCallDetail(row, index) {
      let that = this;
      that.allData[index].customers = [];
      that.allData[index].customers = row.customers;
      that.allData[index].customerTitle = row.user_name;
    },
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const Selects = this.$refs;
          console.log(Selects);
          if (Selects.agent1Select) {
            const input =
              Selects.agent1Select.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
          }
          if (Selects.agent2Select) {
            const appinput =
              Selects.agent2Select.$el.querySelector(".el-input__inner");
            appinput.removeAttribute("readonly");
          }
          if (Selects.agent3Select) {
            const gameinput =
              Selects.agent3Select.$el.querySelector(".el-input__inner");
            gameinput.removeAttribute("readonly");
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.page {
  overflow: hidden;
}
.normal{
  margin: 12px 0 !important;
  text-align: left !important;
}
.give-box {
  margin-left: 50px;
  margin-top: 50px;
}
.sale-box {
  display: inline-block;
}
.sale-box > div {
  display: inline-block;
  padding: 4px;
  background-color: #eee;
  border-radius: 5px;
  margin:0px 10px
}
.sale-box > .current-sale {
  background-color: red;
}

.check-box {
  margin-left: 50px;
  margin-top: 50px;
}
.use {
  margin-top: 50px;
}
.top-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
.top-title div {
  margin-right: 10px;
}
.customer-box {
  margin: 20px 0 60px;
}
.audio-box {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/page/giveCustomers.vue